// import firebase from 'react-native-firebase';

import { IS_WEB } from './appConstants';

export default () => {
  if (IS_WEB) return;

  // firebase.analytics().logEvent(name, params);
};
